function getSliderSettings() {
    return { slidesPerView: 1, navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" } };
}
function getSubSliderProductSettings() {
    return { slidesPerView: 3, direction: "vertical", navigation: !1 };
}
function updatethumbnail() {
    let e = document.querySelector(".product__media-list");
    if (!e) return "";
    let t = e.offsetHeight,
        i = document.querySelector(".product__media-sublist");
    window.innerWidth > 1200 && (i.style.height = t + "px");
}
const sliderInit = (e) => {
    if (
        (document.querySelectorAll(".product-section .js-media-list") && document.querySelectorAll(".product-section .js-media-list").length > 0) ||
        (document.querySelectorAll(".featured-product-section .js-media-list") && document.querySelectorAll(".featured-product-section .js-media-list").length > 0)
    ) {
        let t = new Swiper(".js-media-list", {
            slidesPerView: 1,
            spaceBetween: 4,
            navigation: { nextEl: ".swiper-btn--next", prevEl: ".swiper-btn--prev" },
            on: {
                init: function () {
                    loadActiveDeferredMediaInSwiper(this, { autoplay: true });
                },/*
                slideChangeTransitionStart: function () {
                    document.querySelector(".js-media-sublist").swiper.slideTo(document.querySelector(".js-media-list").swiper.activeIndex);
                },*/
                slideChange: function () {
                    window.pauseAllMedia(this.slides[this.activeIndex]);
                    this.params.noSwiping = !1;
                },
                slideChangeTransitionEnd: function () {
                    this.slides[this.activeIndex].querySelector("model-viewer") && this.slides[this.activeIndex].querySelector(".shopify-model-viewer-ui__button--poster").removeAttribute("hidden");
                    loadActiveDeferredMediaInSwiper(this, { autoplay: true });
                },
                touchStart: function (e, t) {
                    this.slides[this.activeIndex].querySelector("model-viewer") &&
                        (this.slides[this.activeIndex].querySelector("model-viewer").classList.contains("shopify-model-viewer-ui__disabled")
                            ? (this.params.noSwiping = !1)
                            : ((this.params.noSwiping = !0), (this.params.noSwipingClass = "swiper-slide")));
                },
            },
        });
        updatethumbnail(),
            e &&
                setTimeout(function () {
                    t.update();
                }, 800);
    }
};
window.addEventListener("resize", () => {
    updatethumbnail();
}),
    document.addEventListener("shopify:section:load", function () {
        updatethumbnail();
    });
const subSliderInit = (e) => {
    if (document.querySelector('.product-section .js-media-sublist')) {
        return;
    }
    if (
        (document.querySelectorAll(".product-section .js-media-sublist") && document.querySelectorAll(".product-section .js-media-sublist").length > 0) ||
        (document.querySelectorAll(".featured-product-section .js-media-sublist") && document.querySelectorAll(".featured-product-section .js-media-sublist").length > 0)
    ) {
        let t = new Swiper(".js-media-sublist", {
            centeredSlides: !0,
            centeredSlidesBounds: !0,
            slideToClickedSlide: !0,
            watchSlidesVisibility: !0,
            watchSlidesProgress: !0,
            slidesPerView: 4,
            spaceBetween: 4,
            autoHeight: !0,
            direction: "horizontal",
            navigation: !1,
            freeMode: !0,
            preloadImages: !1,
            lazy: !0,
            transitionStart: function () {
                document.querySelector(".js-media-list").swiper.slideTo(document.querySelector(".js-media-sublist").swiper.activeIndex);
            },
            breakpoints: { 1200: { direction: "vertical", slidesPerView: "auto", allowTouchMove: !0 } },
            on: {
                touchEnd: function (e, t) {
                    let i = (e.touches.diff = e.isHorizontal() ? e.touches.currentX - e.touches.startX : e.touches.currentY - e.touches.startY);
                    (i < 5 || i > -5) && (e.allowClick = !0);
                },
            },
            transitionStart: function () {
                document.querySelector(".js-media-list").swiper.slideTo(document.querySelector(".js-media-sublist").swiper.activeIndex);
            },
        });
        t.slides.length <= 3 && ((t.params.centeredSlides = !1), t.update()),
            e &&
                setTimeout(function () {
                    t.update();
                }, 200);
    }
};
function getFocusableElements(e) {
    return Array.from(e.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
function onKeyUpEscape(e) {
    if ("ESCAPE" !== e.code.toUpperCase()) return;
    const t = e.target.closest("details[open]");
    if (!t) return;
    const i = t.querySelector("summary");
    t.removeAttribute("open"), i.setAttribute("aria-expanded", !1), i.focus();
}
document.querySelectorAll('[id^="Details-"] summary').forEach((e) => {
    e.setAttribute("role", "button"),
        e.setAttribute("aria-expanded", "false"),
        e.nextElementSibling.getAttribute("id") && e.setAttribute("aria-controls", e.nextElementSibling.id),
        e.addEventListener("click", (e) => {
            e.currentTarget.setAttribute("aria-expanded", !e.currentTarget.closest("details").hasAttribute("open"));
        }),
        e.closest("header-drawer") || e.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(e, t = e) {
    var i = getFocusableElements(e),
        s = i[0],
        n = i[i.length - 1];
    removeTrapFocus(),
        (trapFocusHandlers.focusin = (t) => {
            (t.target !== e && t.target !== n && t.target !== s) || document.addEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.focusout = function () {
            document.removeEventListener("keydown", trapFocusHandlers.keydown);
        }),
        (trapFocusHandlers.keydown = function (t) {
            "TAB" === t.code.toUpperCase() && (t.target !== n || t.shiftKey || (t.preventDefault(), s.focus()), (t.target !== e && t.target !== s) || !t.shiftKey || (t.preventDefault(), n.focus()));
        }),
        document.addEventListener("focusout", trapFocusHandlers.focusout),
        document.addEventListener("focusin", trapFocusHandlers.focusin),
        t.focus();
}
function pauseAllMedia(excludeElement = null) {
    const isExcluded = (element) => excludeElement && excludeElement.contains(element);

    document.querySelectorAll(".js-youtube").forEach((e) => {
        if (!isExcluded(e)) {
            e.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*");
        }
    });
    document.querySelectorAll(".js-vimeo").forEach((e) => {
        if (!isExcluded(e)) {
            e.contentWindow.postMessage('{"method":"pause"}', "*");
        }
    });
    document.querySelectorAll("video").forEach((e) => {
        if (!isExcluded(e)) {
            e.pause();
        }
    });
    document.querySelectorAll("product-model").forEach((e) => {
        if (!isExcluded(e)) {
            e.modelViewerUI && e.modelViewerUI.pause();
        }
    });
}
function getActiveDeferredMedia(swiper) {
    if (!swiper) return null;
    const activeSlide = swiper.slides?.[swiper.activeIndex] || swiper.el?.querySelector('.swiper-slide-active');
    return activeSlide ? activeSlide.querySelector('deferred-media, product-model') : null;
}
function loadActiveDeferredMediaInSwiper(swiper, options = {}) {
    if (!swiper) return;
    const activeSlide = swiper.slides?.[swiper.activeIndex] || swiper.el?.querySelector('.swiper-slide-active');
    if (!activeSlide) return;
    window.pauseAllMedia(activeSlide);
    const media = activeSlide.querySelector('deferred-media, product-model');
    if (media && typeof media.loadContent === 'function') {
        window.requestAnimationFrame(() => media.loadContent(options));
    }
}
function removeTrapFocus(e = null) {
    document.removeEventListener("focusin", trapFocusHandlers.focusin), document.removeEventListener("focusout", trapFocusHandlers.focusout), document.removeEventListener("keydown", trapFocusHandlers.keydown), e && e.focus();
}
class QuantityInput extends HTMLElement {
    constructor() {
        super(), (this.input = this.querySelector("input")), (this.changeEvent = new Event("change", { bubbles: !0 })), this.querySelectorAll("button").forEach((e) => e.addEventListener("click", this.onButtonClick.bind(this)));
        for (event of ["paste", "input"])
            this.input.addEventListener(event, function (e) {
                /^0*?[1-9]\d*$/.test(e.currentTarget.value) || "" === e.currentTarget.value ? e.currentTarget.value : (e.currentTarget.value = 1);
            });
        this.input.addEventListener("focusout", function (e) {
            "" === e.currentTarget.value && (e.currentTarget.value = 1);
        });
    }
    onButtonClick(e) {
        e.preventDefault();
        const t = this.input.value;
        "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown(), t !== this.input.value && this.input.dispatchEvent(this.changeEvent);
    }
}
function debounce(e, t) {
    let i;
    return (...s) => {
        clearTimeout(i), (i = setTimeout(() => e.apply(this, s), t));
    };
}
customElements.define("quantity-input", QuantityInput);
const serializeForm = (e) => {
    const t = {},
        i = new FormData(e);
    for (const e of i.keys()) t[e] = i.get(e);
    return JSON.stringify(t);
};
function fetchConfig(e = "json") {
    return { method: "POST", headers: { "Content-Type": "application/json", Accept: `application/${e}` } };
}
void 0 === window.Shopify && (window.Shopify = {}),
    (Shopify.bind = function (e, t) {
        return function () {
            return e.apply(t, arguments);
        };
    }),
    (Shopify.setSelectorByValue = function (e, t) {
        for (var i = 0, s = e.options.length; i < s; i++) {
            var n = e.options[i];
            if (t == n.value || t == n.innerHTML) return (e.selectedIndex = i), i;
        }
    }),
    (Shopify.addListener = function (e, t, i) {
        e.addEventListener ? e.addEventListener(t, i, !1) : e.attachEvent("on" + t, i);
    }),
    (Shopify.postLink = function (e, t) {
        var i = (t = t || {}).method || "post",
            s = t.parameters || {},
            n = document.createElement("form");
        for (var r in (n.setAttribute("method", i), n.setAttribute("action", e), s)) {
            var o = document.createElement("input");
            o.setAttribute("type", "hidden"), o.setAttribute("name", r), o.setAttribute("value", s[r]), n.appendChild(o);
        }
        document.body.appendChild(n), n.submit(), document.body.removeChild(n);
    }),
    (Shopify.CountryProvinceSelector = function (e, t, i) {
        (this.countryEl = document.getElementById(e)),
            (this.provinceEl = document.getElementById(t)),
            (this.provinceContainer = document.getElementById(i.hideElement || t)),
            Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
            this.initCountry(),
            this.initProvince();
    }),
    (Shopify.CountryProvinceSelector.prototype = {
        initCountry: function () {
            var e = this.countryEl.getAttribute("data-default");
            Shopify.setSelectorByValue(this.countryEl, e), this.countryHandler();
        },
        initProvince: function () {
            var e = this.provinceEl.getAttribute("data-default");
            e && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, e);
        },
        countryHandler: function (e) {
            var t = (n = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
                i = JSON.parse(t);
            if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = "none";
            else {
                for (var s = 0; s < i.length; s++) {
                    var n;
                    ((n = document.createElement("option")).value = i[s][0]), (n.innerHTML = i[s][1]), this.provinceEl.appendChild(n);
                }
                this.provinceContainer.style.display = "";
            }
        },
        clearOptions: function (e) {
            for (; e.firstChild; ) e.removeChild(e.firstChild);
        },
        setOptions: function (e, t) {
            var i = 0;
            for (t.length; i < t.length; i++) {
                var s = document.createElement("option");
                (s.value = t[i]), (s.innerHTML = t[i]), e.appendChild(s);
            }
        },
    });
class MenuDrawer extends HTMLElement {
    constructor() {
        super(), (this.mainDetailsToggle = this.querySelector("details"));
        const e = this.querySelectorAll("summary");
        this.addAccessibilityAttributes(e),
            "iPhone" === navigator.platform && document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`),
            this.addEventListener("keyup", this.onKeyUp.bind(this)),
            this.addEventListener("focusout", this.onFocusOut.bind(this)),
            this.bindEvents();
    }
    bindEvents() {
        this.querySelectorAll("summary").forEach((e) => e.addEventListener("click", this.onSummaryClick.bind(this))),
            this.querySelectorAll("button").forEach((e) => {
                this.querySelector(".header__localization-button") !== e && this.querySelector(".header__localization-lang-button") !== e && e.addEventListener("click", this.onCloseButtonClick.bind(this));
            });
    }
    addAccessibilityAttributes(e) {
        e.forEach((e) => {
            e.setAttribute("role", "button"), e.setAttribute("aria-expanded", !1), e.setAttribute("aria-controls", e.nextElementSibling.id);
        });
    }
    onKeyUp(e) {
        if ("ESCAPE" !== e.code.toUpperCase()) return;
        const t = e.target.closest("details[open]");
        t && (t === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary")) : this.closeSubmenu(t));
    }
    onSummaryClick(e) {
        const t = e.currentTarget,
            i = t.parentNode,
            s = i.hasAttribute("open");
        i === this.mainDetailsToggle
            ? (s && e.preventDefault(), s ? this.closeMenuDrawer(t) : this.openMenuDrawer(t))
            : (trapFocus(t.nextElementSibling, i.querySelector("button")),
              setTimeout(() => {
                  i.classList.add("menu-opening");
              }));
    }
    openMenuDrawer(e) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add("menu-opening");
        }),
            e.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, e),
            document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
    closeMenuDrawer(e, t = !1) {
        void 0 !== e &&
            (this.mainDetailsToggle.classList.remove("menu-opening"),
            this.mainDetailsToggle.querySelectorAll("details").forEach((e) => {
                e.removeAttribute("open"), e.classList.remove("menu-opening");
            }),
            this.mainDetailsToggle.querySelector("summary").setAttribute("aria-expanded", !1),
            document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`),
            removeTrapFocus(t),
            this.closeAnimation(this.mainDetailsToggle));
    }
    onFocusOut(e) {
        setTimeout(() => {
            this.mainDetailsToggle.hasAttribute("open") && !this.mainDetailsToggle.contains(document.activeElement) && this.closeMenuDrawer();
        });
    }
    onCloseButtonClick(e) {
        const t = e.currentTarget.closest("details");
        this.closeSubmenu(t);
    }
    closeSubmenu(e) {
        e.classList.remove("menu-opening"), removeTrapFocus(), this.closeAnimation(e);
    }
    closeAnimation(e) {
        let t;
        const i = (s) => {
            void 0 === t && (t = s);
            s - t < 400 ? window.requestAnimationFrame(i) : (e.removeAttribute("open"), e.closest("details[open]") && trapFocus(e.closest("details[open]"), e.querySelector("summary")));
        };
        window.requestAnimationFrame(i);
    }
}
customElements.define("menu-drawer", MenuDrawer);
class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }
    openMenuDrawer(e) {
        (this.header = this.header || document.getElementById("shopify-section-header")),
            (this.borderOffset = this.borderOffset || this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom") ? 1 : 0),
            document.documentElement.style.setProperty("--header-bottom-position", `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`),
            setTimeout(() => {
                this.mainDetailsToggle.classList.add("menu-opening");
            }),
            e.setAttribute("aria-expanded", !0),
            trapFocus(this.mainDetailsToggle, e),
            document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    }
}
customElements.define("header-drawer", HeaderDrawer);
class ModalDialog extends HTMLElement {
    constructor() {
        super(),
            this.querySelector('[id^="ModalClose-"]').addEventListener("click", this.hide.bind(this, !1)),
            this.addEventListener("keyup", (e) => {
                "ESCAPE" === e.code.toUpperCase() && this.hide();
            }),
            this.classList.contains("media-modal")
                ? this.addEventListener("pointerup", (e) => {
                      "mouse" !== e.pointerType || e.target.closest("deferred-media, product-model") || this.hide();
                  })
                : this.addEventListener("click", (e) => {
                      e.target === this && this.hide();
                  });
    }
    connectedCallback() {
        this.moved || ((this.moved = !0), document.body.appendChild(this));
    }
    show(e) {
        this.openedBy = e;
        const t = this.querySelector(".template-popup");
        document.body.classList.add("overflow-hidden"), this.setAttribute("open", ""), t && t.loadContent(), trapFocus(this, this.querySelector('[role="dialog"]')), window.pauseAllMedia();
    }
    hide() {
        let e = !1;
        this.removeAttribute("open"),
            removeTrapFocus(this.openedBy),
            window.pauseAllMedia(),
            document.querySelectorAll("body > quick-add-modal").forEach((t) => {
                t.hasAttribute("open") && (e = !0);
            }),
            e || (document.body.classList.remove("overflow-hidden"), document.body.dispatchEvent(new CustomEvent("modalClosed")));
    }
}
customElements.define("modal-dialog", ModalDialog);
class ModalOpener extends HTMLElement {
    constructor() {
        super();
        const e = this.querySelector("button");
        e &&
            e.addEventListener("click", () => {
                const t = document.querySelector(this.getAttribute("data-modal"));
                t && t.show(e);
            });
    }
}
customElements.define("modal-opener", ModalOpener);
class DeferredMedia extends HTMLElement {
    constructor() {
        super(), this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener("click", this.loadContent.bind(this)), this.getAttribute("data-autoplay") && this.loadContent();
    }
    autoplayIframe(iframe) {
        if (!iframe) return;
        iframe.setAttribute('allow', 'autoplay; encrypted-media');
        iframe.setAttribute('allowfullscreen', '');
        if (iframe.classList.contains('js-youtube')) {
            iframe.contentWindow?.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
        } else if (iframe.classList.contains('js-vimeo')) {
            iframe.contentWindow?.postMessage('{"method":"play"}', '*');
        }
    }
    setSafariAttributes(autoplay = false) {
        let e = this.querySelector("video");
        if (e) {
            e.autoplay = !!autoplay;
            e.setAttribute("webkit-playsinline", "");
            e.setAttribute("playsinline", "");
            if (autoplay) {
                e.muted = true;
                e.setAttribute("muted", "");
            }
            const playPromise = e.play();
            if (playPromise && typeof playPromise.catch === "function") {
                playPromise.catch((err) => {
                    if (err && err.name !== "AbortError" && err.name !== "NotAllowedError") {
                        console.error(err);
                    }
                });
            }
            return;
        }

        if (autoplay) {
            const iframe = this.querySelector("iframe");
            this.autoplayIframe(iframe);
        }
    }
    playLoadedContent(options = {}) {
        let e = this.querySelector("video");
        if (e) {
            if (options.autoplay) {
                e.autoplay = true;
                e.muted = true;
                e.setAttribute("muted", "");
            }
            const playPromise = e.play();
            if (playPromise && typeof playPromise.catch === "function") {
                playPromise.catch((err) => {
                    if (err && err.name !== "AbortError" && err.name !== "NotAllowedError") {
                        console.error(err);
                    }
                });
            }
            return;
        }

        if (options.autoplay) {
            const iframe = this.querySelector("iframe");
            this.autoplayIframe(iframe);
        }
    }
    loadContent(options = {}) {
        if (!this.getAttribute("loaded")) {
            const e = document.createElement("div");
            e.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(!0));
            this.setAttribute("loaded", !0);
            const activeSlide = this.closest(".swiper")?.swiper.slides[this.closest(".swiper").swiper.activeIndex] || this;
            window.pauseAllMedia(activeSlide);
            const mediaElement = e.querySelector("video, model-viewer, iframe");
            this.appendChild(mediaElement).focus();
            this.setSafariAttributes(options.autoplay);
            this.closest(".swiper")?.swiper.slides[this.closest(".swiper").swiper.activeIndex].querySelector("model-viewer") &&
                (this.closest(".swiper").swiper.slides[this.closest(".swiper").swiper.activeIndex].querySelector("model-viewer").classList.contains("shopify-model-viewer-ui__disabled") ||
                    ((this.closest(".swiper").swiper.params.noSwiping = !0), (this.closest(".swiper").swiper.params.noSwipingClass = "swiper-slide")));
        } else if (options.autoplay) {
            this.playLoadedContent(options);
        }
    }
}
customElements.define("deferred-media", DeferredMedia);
class SliderComponent extends HTMLElement {
    constructor() {
        if (
            (super(),
            (this.slider = this.querySelector(".slider")),
            (this.sliderItems = this.querySelectorAll(".slider__slide")),
            (this.pageCount = this.querySelector(".slider-counter--current")),
            (this.pageTotal = this.querySelector(".slider-counter--total")),
            (this.prevButton = this.querySelector('button[name="previous"]')),
            (this.nextButton = this.querySelector('button[name="next"]')),
            !this.slider || !this.nextButton)
        )
            return;
        new ResizeObserver((e) => this.initPages()).observe(this.slider),
            this.slider.addEventListener("scroll", this.update.bind(this)),
            this.prevButton.addEventListener("click", this.onButtonClick.bind(this)),
            this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    }
    initPages() {
        0 !== !this.sliderItems.length && ((this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItems[0].clientWidth)), (this.totalPages = this.sliderItems.length - this.slidesPerPage + 1), this.update());
    }
    update() {
        this.pageCount &&
            this.pageTotal &&
            ((this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1),
            1 === this.currentPage ? this.prevButton.setAttribute("disabled", !0) : this.prevButton.removeAttribute("disabled"),
            this.currentPage === this.totalPages ? this.nextButton.setAttribute("disabled", !0) : this.nextButton.removeAttribute("disabled"),
            (this.pageCount.textContent = this.currentPage),
            (this.pageTotal.textContent = this.totalPages));
    }
    onButtonClick(e) {
        e.preventDefault();
        const t = "next" === e.currentTarget.name ? this.slider.scrollLeft + this.sliderItems[0].clientWidth : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
        this.slider.scrollTo({ left: t });
    }
}
customElements.define("slider-component", SliderComponent);
class VariantSelects extends HTMLElement {
    constructor() {
        super(), this.addEventListener("change", this.onVariantChange)
        // , console.log(this.updateURL());
    }/*
    onVariantChange() {
        this.updateOptions(),
            this.updateMasterId(),
            this.toggleAddButton(!0, "", !1),
            this.updatePickupAvailability(),
            this.updateVariantStatuses(),
            this.filterMedia(),
            this.currentVariant ? (this.updateMediaSub(), this.updateMedia(), this.updateURL(), this.filterMedia(), this.updateVariantInput(), this.renderProductInfo()) : (this.toggleAddButton(!0, "", !0), this.setUnavailable());
    }*/
    updateOptions() {
        const e = Array.from(this.querySelectorAll(".js-radio-colors"));
        this.options = Array.from(this.querySelectorAll("select"), (e) => e.value).concat(e.map((e) => Array.from(e.querySelectorAll("input")).find((e) => e.checked).value));
    }
    updateMasterId() {
        (this.variantData || this.querySelector('[type="application/json"]')) &&
            (this.currentVariant = this.getVariantData().find((e) => (this.options.sort(), e.options.sort(), !e.options.map((e, t) => this.options[t] === e).includes(!1))));
    }
    updateMedia() {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;
        const e = document.querySelector(`[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
        if (!e) return;
        const t = e.parentElement;
        t.prepend(e),
            window.setTimeout(() => {
                t.scroll(0, 0);
            }),
            document.querySelector(".js-media-list") && sliderInit();
    }
    updateMediaSub() {
        if (!this.currentVariant || !this.currentVariant?.featured_media) return;
        const e = document.querySelector(`[data-media-sub-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`);
        if ((document.querySelector(".js-media-sublist") && null != document.querySelector(".js-media-sublist").swiper && document.querySelector(".js-media-sublist").swiper.destroy(), !e)) return;
        const t = e.parentElement;
        t.prepend(e),
            window.setTimeout(() => {
                t.scroll(0, 0);
            }),
            document.querySelector(".js-media-sublist") && subSliderInit();
    }
    updateURL() {
        this.currentVariant && "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
    updateVariantInput() {
        document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`).forEach((e) => {
            const t = e.querySelector('input[name="id"]');
            (t.value = this.currentVariant.id), t.dispatchEvent(new Event("change", { bubbles: !0 }));
        });
    }
    updateVariantStatuses() {
        const e = this.variantData.filter((e) => this.querySelector(":checked").value === e.option1),
            t = [...this.querySelectorAll(".product-form__input")];
        t.forEach((i, s) => {
            if (0 === s) return;
            const n = [...i.querySelectorAll('input[type="radio"], option')],
                r = t[s - 1].querySelector(":checked").value,
                o = e.filter((e) => e.available && e[`option${s}`] === r).map((e) => e[`option${s + 1}`]);
            this.setInputAvailability(n, o);
        });
    }
    setInputAvailability(e, t) {
        e.forEach((e) => {
            t.includes(e.getAttribute("value"))
                ? "OPTION" === e.tagName
                    ? (e.innerText = e.getAttribute("value"))
                    : "INPUT" === e.tagName && e.classList.remove("disabled")
                : "OPTION" === e.tagName
                ? (e.innerText = window.variantStrings.unavailable_with_option.replace("[value]", e.getAttribute("value")))
                : "INPUT" === e.tagName && e.classList.add("disabled");
        });
    }
    updatePickupAvailability() {
        const e = document.querySelector("pickup-availability");
        e && (this.currentVariant && this.currentVariant.available ? e.fetchAvailability(this.currentVariant.id) : (e.removeAttribute("available"), (e.innerHTML = "")));
    }
    renderProductInfo() {
        const e = this.currentVariant.id,
            t = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
            .then((e) => e.text())
            .then((i) => {
                if (this.currentVariant.id !== e) return;
                const s = new DOMParser().parseFromString(i, "text/html"),
                    n = document.getElementById(`price-${this.dataset.section}`),
                    r = s.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
                    o = s.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
                    a = document.getElementById(`Sku-${this.dataset.section}`),
                    l = s.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`),
                    d = document.getElementById(`Inventory-${this.dataset.section}`);
                r && n && (n.innerHTML = r.innerHTML), l && d && (d.innerHTML = l.innerHTML), o && a && ((a.innerHTML = o.innerHTML), a.classList.toggle("visibility-hidden", o.classList.contains("visibility-hidden")));
                const c = document.getElementById(`price-${this.dataset.section}`);
                c && c.classList.remove("visibility-hidden"), d && d.classList.toggle("visibility-hidden", "" === l.innerText);
                const u = s.getElementById(`ProductSubmitButton-${t}`);
                this.toggleAddButton(
                    !u || u.hasAttribute("disabled"),
                    //!this.currentVariant.available,
                    window.variantStrings.soldOut
                );
            });
    }
    toggleAddButton(e = !0, t, i = !0) {
        const s = document.getElementById(`product-form-${this.dataset.section}`);
        if (!s) return;
        const n = s.querySelector('[name="add"]'),
            r = s.querySelectorAll('[name="add"] > .add_to_cart_quantity');
        n &&
            (e
                ? (n.setAttribute("disabled", "disabled"),
                  t &&
                      r.forEach((e) => {
                          e.innerHTML = `${t}`;
                      }))
                : (n.removeAttribute("disabled"),
                  r.forEach((e) => {
                      e.innerHTML = `${window.variantStrings.addToCart}`;
                  })));
    }
    setUnavailable() {
        const e = document.getElementById(`product-form-${this.dataset.section}`),
            t = e.querySelector('[name="add"]'),
            i = e.querySelectorAll('[name="add"] > .add_to_cart_quantity'),
            s = document.getElementById(`price-${this.dataset.section}`),
            n = document.getElementById(`Inventory-${this.dataset.section}`),
            r = document.getElementById(`Sku-${this.dataset.section}`);
        t &&
            (i.forEach((e) => {
                e.innerHTML = `${window.variantStrings.unavailable}`;
            }),
            s && s.classList.add("visibility-hidden"),
            n && n.classList.add("visibility-hidden"),
            r && r.classList.add("visibility-hidden"));
    }
    getVariantData() {
        return (this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent)), this.variantData;
    }
    filterMedia() {
        console.log(this)
        console.log(this.currentVariant.title);
        var e = this.currentVariant.title.replace("/", "").replace("  ", "").replace(" ", "").replace("/", "").replace(" ", "");
        console.log(e);
        var t = this.currentVariant.title.split(" / ")[0].replaceAll(" ", "");
        if (
            document.querySelectorAll(".js-media-sublist [data-color='" + t + "']")
              .length == 0
          ) {
           color = $('.asas.color-swatch').first().attr('title')
           $('.asas.color-swatch').first().click()
           $('.subtitle.pills-variant-labels').filter(function() {
             const computedStyle = window.getComputedStyle(this, '::before');
             return computedStyle.content === 'none';
           }).first().click();
          }
        if ((console.log("color " + t), console.log(document.querySelectorAll(".js-media-sublist [data-color='" + t + "']").length), document.querySelectorAll(".js-media-sublist [data-color='" + t + "']").length > 0)) {
            Array.prototype.forEach.call(document.querySelectorAll(".js-media-sublist [data-color]:not([data-color='" + t + "'])"), (e) => {
                e.classList.add("non-swiper-slide"), e.classList.remove("swiper-slide"), e.removeAttribute("style");
            }),
                Array.prototype.forEach.call(document.querySelectorAll(".js-media-sublist [data-color='" + t + "']"), (e) => {
                    e.classList.remove("non-swiper-slide"), e.classList.add("swiper-slide"), e.removeAttribute("style");
                }),
                Array.prototype.forEach.call(document.querySelectorAll(".js-media-list [data-color]:not([data-color='" + t + "'])"), (e) => {
                    e.classList.add("non-swiper-slide"), e.classList.remove("swiper-slide"), e.removeAttribute("style");
                }),
                Array.prototype.forEach.call(document.querySelectorAll(".js-media-list [data-color='" + t + "']"), (e) => {
                    e.classList.remove("non-swiper-slide"), e.classList.add("swiper-slide"), e.removeAttribute("style");
                });
            const e = {
                    slidesPerView: 1,
                    spaceBetween: 4,
                    navigation: { nextEl: ".swiper-button-next-prod-slide", prevEl: ".swiper-button-prev-prod-slide" },
                    
                                                        keyboard: {
                                                          enabled: true,
                                                        },
                    /*thumbs: { swiper: document.querySelector(".js-media-sublist").swiper },*/
                    on: {
                        slideChangeTransitionStart: function () {
                            document.querySelector(".js-media-sublist").swiper.slideTo(document.querySelector(".js-media-list").swiper.activeIndex);
                        },
                        slideChange: function () {
                            window.pauseAllMedia(this.slides[this.activeIndex]);
                            this.params.noSwiping = !1;
                        },
                        slideChangeTransitionEnd: function () {
                            this.slides[this.activeIndex].querySelector("model-viewer") && this.slides[this.activeIndex].querySelector(".shopify-model-viewer-ui__button--poster").removeAttribute("hidden");
                            loadActiveDeferredMediaInSwiper(this, { autoplay: true });
                        },
                        touchStart: function (e, t) {
                            this.slides[this.activeIndex].querySelector("model-viewer") &&
                                (this.slides[this.activeIndex].querySelector("model-viewer").classList.contains("shopify-model-viewer-ui__disabled")
                                    ? (this.params.noSwiping = !1)
                                    : ((this.params.noSwiping = !0), (this.params.noSwipingClass = "swiper-slide")));
                        },
                    },
                },
                i = {
                    centeredSlides: !0,
                    centeredSlidesBounds: !0,
                    noSwiping: !0,
                    slideToClickedSlide: !0,
                    watchSlidesVisibility: !0,
                    watchSlidesProgress: !0,
                                                        keyboard: {
                                                          enabled: true,
                                                        },
                    slidesPerView: 4,
                    slidesPerGroup: 1,
                    spaceBetween: 4,
                    autoHeight: !0,
                    direction: "horizontal",
                    navigation: !1,
                    freeMode: !0,
                    preloadImages: !1,
                    lazy: !0,
                    navigation: { nextEl: ".swiper-button-next-prod-slide", prevEl: ".swiper-button-prev-prod-slide" },
                    transitionStart: function () {
                        document.querySelector(".js-media-list").swiper.slideTo(document.querySelector(".js-media-sublist").swiper.activeIndex);
                    },
                    breakpoints: { 1200: { direction: "vertical", slidesPerView: "auto", allowTouchMove: !0 } },
                    on: {
                        click: function () {
                            const e = document.querySelector(".js-media-list").swiper,
                                t = document.querySelector(".js-media-sublist").swiper,
                                i = t.activeIndex;
                            e.slides[i].querySelector("button");
                            e.slideTo(t.activeIndex);
                        },
                        touchEnd: function (e, t) {
                            let i = (e.touches.diff = e.isHorizontal() ? e.touches.currentX - e.touches.startX : e.touches.currentY - e.touches.startY);
                            (i < 5 || i > -5) && (e.allowClick = !0);
                        },
                    },
                };
            if (t == t) {
                console.log("entra al config");
                /*new Swiper(".js-media-sublist", i), new Swiper(".js-media-list", e);*/
            }
        }
    }
}
customElements.define("variant-selects", VariantSelects);
class VariantRadios extends VariantSelects {
    constructor() {
        super();
    }
    setInputAvailability(e, t) {
        e.forEach((e) => {
            t.includes(e.getAttribute("value")) ? e.classList.remove("disabled") : e.classList.add("disabled");
        });
    }
    updateOptions() {
        const e = Array.from(this.querySelectorAll("fieldset"));
        this.options = e.map((e) => Array.from(e.querySelectorAll("input")).find((e) => e.checked).value);
    }
}
customElements.define("variant-radios", VariantRadios),
    (function () {
        const e = (e) => (
            (e = e || {}),
            (this.nameSpaces = { wrapper: e.wrapper || ".parallax", layers: e.layers || ".parallax-layer", deep: e.deep || "data-parallax-deep" }),
            (this.init = function () {
                for (var e = this, t = document.querySelectorAll(this.nameSpaces.wrapper), i = 0; i < t.length; i++)
                    !(function (i) {
                        t[i].addEventListener("mousemove", function (s) {
                            for (var n = s.clientX, r = s.clientY, o = t[i].querySelectorAll(e.nameSpaces.layers), a = 0; a < o.length; a++)
                                !(function (t) {
                                    var i = o[t].getAttribute(e.nameSpaces.deep),
                                        s = o[t].getAttribute("data-parallax-disallow"),
                                        a = s && "x" === s ? 0 : n / i,
                                        l = s && "y" === s ? 0 : r / i;
                                    (s && "both" === s) || (o[t].style.transform = "translateX(" + a + "%) translateY(" + l + "%)");
                                })(a);
                        });
                    })(i);
            }),
            this.init(),
            this
        );
        document.addEventListener("shopify:section:load", e), e();
    })(),
    (function () {
        let e = () => {
            let e = document.querySelector(".article-template"),
                t = document.querySelector(".article-template__header"),
                i = document.querySelector(".header-wrapper"),
                s =
                    document.querySelector(".header > .header__heading-link .header__heading-logo:not(.header__heading-logo--overlay)") ||
                    document.querySelector(".header > .header__heading .header__heading-link .header__heading-logo:not(.header__heading-logo--overlay)"),
                n = document.querySelector(".header__heading-logo--overlay");
            n ? (s && s.classList.add("hide"), n.classList.add("show")) : s && s.classList.remove("hide"),
                e && e.classList.contains("section-template--overlay") ? i && i.classList.add("header-wrapper--overlay") : i && i.classList.remove("header-wrapper--overlay");
            let r = document.querySelector(".article-template__hero > .media");
            r && (r.classList.contains("article-template__hero-large") ? t.classList.add("article-template__header-large") : t.classList.remove("article-template__header-large"));
            const o = document.getElementById("MainContent").querySelectorAll(".shopify-section"),
                a = o[0].querySelector(".section--has-overlay");
            o.forEach((e) => {
                const t = o[0].querySelector("div");
                ((o[0].classList.contains("section--overlay") && t.classList.contains("color-background-3")) || a) &&
                    (i.classList.add("header-wrapper--overlay"), n ? (s && s.classList.add("hide"), n.classList.add("show")) : s && s.classList.remove("hide"));
            });
        };
        document.addEventListener("shopify:section:load", function () {
            e();
        }),
            window.addEventListener("resize", function () {
                e();
            }),
            e();
    })();

    